export function getDriveThumbnailUrl(url: string, size: number) {
  const match = url.match(/\/d\/([^/]+)/);
  if (!match) return null;
  return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w${size}`;
}
